import './Contact.css'

export const Contact = () => {
    return (
        <div className="contact-wrapper" id='contact'>
            <div className="contact__header">
                <h2 className="contact__title">Contact</h2>
            </div>
            <div className="contact-me">
                <div className="contact__body">
                    <div className="phone">
                        <h3>Phone:</h3>
                        <p className="contact__text">+2348139365956</p>
                        <p className="contact__text">+918143824570</p>
                    </div>
                    <div className="phone">
                        <h3>Email:</h3>
                        <p className="contact__text">bilalmubarakidris@gmail.com</p>
                    </div>
                </div>
            </div>
        </div>
)}